import { SearchCondition } from "./page";
import { Gender, ListObject } from "./common";

/**
 * 필터 타입 (백엔드 계약)
 */
export enum FilterType {
  TEXT = "TEXT",
  SELECT = "SELECT",
  CALENDAR_RANGE = "CALENDAR_RANGE",
  NUMBER_RANGE = "NUMBER_RANGE",
  CHECKBOX = "CHECKBOX",
}

export enum DataSearchTestType {
  KPASS = "KPASS",
  DCAS = "DCAS",
}

/**
 * SELECT 필터의 옵션
 */
interface FilterOption {
  value: string;
  label: string;
}

/**
 * 데이터셋 메타데이터의 필터 정의
 */
interface FilterMeta {
  key: string;
  label: string;
  type: FilterType;
  options?: FilterOption[];
}

/**
 * 데이터셋 메타데이터의 컬럼 정의
 */
interface ColumnMeta {
  key: string;
  label: string;
}

/**
 * 조회가능 데이터셋 메타데이터 (GET /datasets)
 */
interface DatasetMeta {
  key: string;
  label: string;
  filters: FilterMeta[];
  columns: ColumnMeta[];
}

/**
 * 검사결과 데이터 조회 조건 (GET /test-result, /test-result/download)
 * snake_case 변환은 MainApi.toParamStringFromObject 가 처리.
 */
interface TestResultSearchCondition extends SearchCondition {
  q?: string;
  ageYear?: number;
  gender?: Gender;
  state?: string;
  city?: string;
  endedAtFrom?: string; // yyyy-MM-dd
  endedAtTo?: string; // yyyy-MM-dd
  testType?: DataSearchTestType;
  onlyCompleted?: boolean;
  excludeTestAccount?: boolean;
  columns?: string[]; // 다운로드 시 추출할 컬럼 키 목록
}

/**
 * 검사결과 목록 row (TestResultDataListDTO). 백엔드 응답 필드와 정확히 일치.
 */
interface TestResultDataObj extends ListObject {
  name: string;
  userCode: string;
  guardianName: string;
  guardianPhone: string;
  birthday: string;
  testedAt: string;
  ageYear: number;
  ageBand: string;
  gender: Gender;
  state: string;
  city: string;
  chapter1Score: number;
  chapter2Score: number;
  chapter3Score: number;
  chapter4Score: number;
  chapter5Score: number;
}

/**
 * 검사결과 문항별 row (TestResultItemDataListDTO).
 * 원점수: 챕터1~4 = 정오답(0/1), 챕터5 = 실제 채점값(0/1/2).
 */
interface TestResultItemDataObj extends ListObject {
  name: string;
  birthday: string;
  testedAt: string;
  ageYear: number;
  ageBand: string;
  gender: Gender;
  state: string;
  city: string;
  chapter: number;
  questionNumber: number;
  rawScore: number;
}

/**
 * 검사결과 문항 원점수(가로) row (TestResultItemWideDTO).
 * 사람당 1행, 각 문항의 원점수를 가로 컬럼(scores["chapter-question"])으로 포함.
 */
interface TestResultWideDataObj extends ListObject {
  name: string;
  userCode?: string;
  guardianName?: string;
  guardianPhone?: string;
  birthday: string;
  testedAt: string;
  ageYear: number;
  ageBand: string;
  gender: Gender;
  state: string;
  city: string;
  scores: Record<string, number>;
}

export type {
  FilterOption,
  FilterMeta,
  ColumnMeta,
  DatasetMeta,
  TestResultSearchCondition,
  TestResultDataObj,
  TestResultItemDataObj,
  TestResultWideDataObj,
};
